
export default defineNuxtRouteMiddleware(async (to) => {
  const user = useUserStore()
  const userHistory = useUserHistoryStore()
  const team = useTeamStore()
  const teamSlug = to.params?.team
  const isTeamPage = to.name.startsWith('team') && to.name !== 'teams'

  // Ensure fetching and storing team data
  if (isTeamPage && teamSlug !== team.slug) {
    try {
      const response = await $fetch(`/api/v1/teams/${teamSlug}`, {
        key: `team-${teamSlug}`, 
        baseURL: useEnv('apiBase'),
      })
      team.addTeam(response)
    } catch (error) {
      // Reset team on error
      team.$reset()
    }
  }

  // Add to history 
  if (isTeamPage && to.name !== 'team-game') {
    userHistory.addToHistory({ 
      id: team?.id, // || response?.team?.id,
      date: useDate().format('YYYY-MM-DD HH:mm:ss'),
      type: 'team',
      href: to.href,
      slug: team?.slug,
      name: team?.name,
      abbr: team?.abbr,
      logo: team?.logo,
    })
  }
})